export default __webpack_public_path__ + "static/create-experiment-dark-mode-e8849c48d3cce475de634d9d081e49c8.png";